<template>
  <VaccinationPage
    title="Traveling"
    :buttons="buttons"
    baseRoute="/TravelingSecondPage"
    :bottomImage="require('@/assets/page25/Asset 252.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/vaccination"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page25/Asset 244.png"), name: "Influenza" },
  { imgPath: require("@/assets/page25/Asset 245.png"), name: "MeningococcalMenB" },
  { imgPath: require("@/assets/page25/Asset 246.png"), name: "yellowFever" },
  { imgPath: require("@/assets/page25/Asset 247.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page25/Asset 248.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page25/Asset 249.png"), name: "RSV" },
  { imgPath: require("@/assets/page25/Asset 261.png"), name: "Zoster" },
  { imgPath: require("@/assets/page25/Asset 256.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page25/Asset 257.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page25/Asset 258.png"), name: "Typhoid" },
  { imgPath: require("@/assets/page25/Asset 259.png"), name: "MMR" },
  { imgPath: require("@/assets/page25/Asset 260.png"), name: "Varicella" },
];
</script>